import { SearchableSelectOption } from "utils/searchableOptions";

// The option value is the internal group id, which is what activity records
// store and what the alert condition matches on.
export type AlertGroupOption = SearchableSelectOption<string> & {
    directoryId: string
    directoryName: string
};

export const UNKNOWN_GROUP_LABEL = "Unknown group";

// A saved condition can name a group the group list no longer returns, for
// example a deleted group or a group of a disabled directory. It stays
// selectable so the user can still remove it from the condition.
export function withSelectedAlertGroups(
    available: AlertGroupOption[],
    selectedValues: string[],
): AlertGroupOption[] {
    const seen = new Set(available.map(option => option.value));
    const unknown: AlertGroupOption[] = [];
    for (const value of selectedValues) {
        if (seen.has(value)) continue;
        seen.add(value);
        unknown.push({ value, label: UNKNOWN_GROUP_LABEL, directoryId: "", directoryName: "" });
    }

    return unknown.length ? [...available, ...unknown] : available;
}

export function alertGroupValueLabel(available: AlertGroupOption[], value: string): string {
    return available.find(option => option.value === value)?.label || UNKNOWN_GROUP_LABEL;
}
